import PgCTLExecutiveBadge from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-executive-badge.webp"
import PgCTLExecutiveBadgeMobile from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-executive-badge-mobile.webp"
import PgCTLProfessionalBadge from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-professional-badge.webp"
import PgCTLProfessionalBadgeMobile from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-professional-badge-mobile.webp"
import PgCTLStarterBadge from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-starter-badge.webp"
import PgCTLStarterBadgeMobile from "assets/WelcomeDialogOnboarding/PgCTL/GetStarted/pgctl-starter-badge-mobile.webp"
import { PgCTLProductSlugsEnum } from "utils/constants"

export const getPgCTLProdDetails = (slug: string) => {
  switch (slug) {
    case PgCTLProductSlugsEnum.starter:
      return {
        badge: { web: PgCTLStarterBadge, mobile: PgCTLStarterBadgeMobile },
        text: "PgCTL - Starter",
      }
    case PgCTLProductSlugsEnum.executive:
      return {
        badge: { web: PgCTLExecutiveBadge, mobile: PgCTLExecutiveBadgeMobile },
        text: "PgCTL - Executive",
      }
    case PgCTLProductSlugsEnum.professional:
      return {
        badge: {
          web: PgCTLProfessionalBadge,
          mobile: PgCTLProfessionalBadgeMobile,
        },
        text: "PgCTL - Professional",
      }

    default:
      return null
    // TODO: Get 1.0 images and enable this
    // case DeliveryMode.LIVE_INSTRUCTOR_LED:
    //   return {
    //     badge: {
    //       web: PgCTLProfessionalBadge,
    //       mobile: PgCTLProfessionalBadgeMobile,
    //     },
    //     text: "PgCTL - Live Instructor Led",
    //   }
    // case DeliveryMode.SELF_PACED:
    //   return {
    //     badge: {
    //       web: PgCTLProfessionalBadge,
    //       mobile: PgCTLProfessionalBadgeMobile,
    //     },
    //     text: "PgCTL - Self Paced",
    //   }
  }
}
